import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortActiveForTeamGrid } from './active-for-team-sort.action';

export function focusSelectorSortActiveForTeamGridReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortActiveForTeamGrid>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } = state.activeFocusesTeamGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        activeFocusesTeamGrid: {
            ...state.activeFocusesTeamGrid,
            sortDefs: nextSortDefs,
        },
    };
}
